export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  HEALTH: "/health", // merged into Executive Summary (ROUTES.HOME); kept as a redirect target for old links
  MENTORS: "/mentors",
  RISK: "/risk",
  PLGS: "/plgs",
  LEARNERS: "/learners",
  MENTOR_DIRECTORY: "/mentors-directory",
  MENTOR_SELECT: "/mentor",
  DATA_QUALITY: "/data-quality",
  IMPORT: "/import",
  FEEDBACK: "/feedback",
  REPORT_PROGRESS: "/report-progress",
  PRIVACY_POLICY: "/privacy",
  LEARNING_ANALYTICS: "/learning-analytics",
  COHORT_ANALYTICS: "/cohort-analytics",
  SCHEDULED_POSTS: "/scheduled-posts",
  SETTINGS: "/settings",
  SETTINGS_BOOKING: "/settings?tab=booking",
  PLG_DETAIL: (id: string | number) => `/plgs/${encodeURIComponent(String(id))}`,
  MENTOR_VIEW: (name: string) => `/mentor/${encodeURIComponent(name)}`,
  // learnerId, not email -- keeps PII out of the URL/browser history/referrers.
  LEARNER_PROFILE: (plgName: string, learnerId: string) => `/mentor/${encodeURIComponent(plgName)}/learner/${encodeURIComponent(learnerId)}`,
  BOOK_MENTOR: (mentorEmail: string) => `/book/${encodeURIComponent(mentorEmail)}`,
  BOOKING_CONFIRMATION: "/book/confirm",
} as const;

export type AppRoute = typeof ROUTES[keyof Omit<typeof ROUTES, 'PLG_DETAIL' | 'MENTOR_VIEW' | 'BOOK_MENTOR' | 'LEARNER_PROFILE'>];
